import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%",
    "height": "100%",
    "border": "1px solid #000"
  }
};
const _hoisted_2 = ["id"];

const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<button class=\"ql-bold\"></button><button class=\"ql-italic\"></button><button class=\"ql-underline\"></button><button class=\"ql-strike\"></button><button class=\"ql-blockquote\"></button><button class=\"ql-code-block\"></button><select class=\"ql-header\"><option value=\"false\" selected></option><option value=\"1\"></option><option value=\"2\"></option><option value=\"3\"></option></select><button class=\"ql-list\" value=\"ordered\"></button><button class=\"ql-list\" value=\"bullet\"></button><button class=\"ql-script\" value=\"sub\"></button><button class=\"ql-script\" value=\"super\"></button><button class=\"ql-indent\" value=\"-1\"></button><button class=\"ql-indent\" value=\"+1\"></button><button class=\"ql-direction\" value=\"rtl\"></button><select class=\"ql-size\"><option value=\"small\"></option><option value=\"false\" selected></option><option value=\"large\"></option><option value=\"huge\"></option></select><select class=\"ql-header\"><option value=\"1\"></option><option value=\"2\"></option><option value=\"3\"></option><option value=\"4\"></option><option value=\"5\"></option><option value=\"6\"></option><option value=\"false\" selected></option></select><select class=\"ql-color\"></select><select class=\"ql-background\"></select><select class=\"ql-align\"></select><button class=\"ql-clean\"></button><button class=\"ql-link\"></button><button class=\"ql-image\"></button><button class=\"ql-video\"></button><button class=\"ql-video-link\"></button>", 24);

const _hoisted_27 = [_hoisted_3];
const _hoisted_28 = ["id"];

const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", {
  class: "ql-image"
}, null, -1);

const _hoisted_30 = /*#__PURE__*/_createElementVNode("button", {
  class: "ql-video"
}, null, -1);

const _hoisted_31 = /*#__PURE__*/_createElementVNode("button", {
  class: "ql-file"
}, null, -1);

const _hoisted_32 = [_hoisted_29, _hoisted_30, _hoisted_31];
const _hoisted_33 = {
  style: {
    "background-color": "rgba(255,255,255,1)",
    "border": "1px solid #000",
    "padding": "2rem",
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "color": "#000"
  }
};
const _hoisted_34 = ["value"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_quill_editor = _resolveComponent("quill-editor");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.theme == 'edit' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: $options.toolbarId,
    ref: $options.toolbarId,
    style: {
      "height": "2rem"
    }
  }, _hoisted_27, 8, _hoisted_2)) : $props.theme == 'chat' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    id: $options.toolbarId,
    ref: $options.toolbarId,
    style: {
      "justify-content": "flex-start",
      "height": "2rem"
    }
  }, _hoisted_32, 8, _hoisted_28)) : _createCommentVNode("", true), _createVNode(_component_quill_editor, {
    ref: $options.quillId,
    options: $options.getEditorOptions(),
    modelValue: $data.content,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.content = $event),
    style: {
      "width": "100%",
      "height": "calc(100% - 2rem)"
    },
    onReady: _cache[1] || (_cache[1] = $event => $options.readyEditor($event)),
    onBlur: _cache[2] || (_cache[2] = $event => $options.blurEditor($event)),
    onFocus: _cache[3] || (_cache[3] = $event => $options.focusEditor($event)),
    onChange: _cache[4] || (_cache[4] = $event => $options.changeEditor($event)),
    disabled: $props.disabled
  }, null, 8, ["options", "modelValue", "disabled"]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("input", {
    ref: $options.fileId,
    type: "file",
    onChange: _cache[5] || (_cache[5] = $event => $options.changeFile($event)),
    multiple: ""
  }, null, 544)], 512), [[_vShow, false]]), $options.uploadProgress && $options.uploadProgress < 1 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
    style: {
      "position": "fixed",
      "left": "0",
      "top": "0",
      "bottom": "0",
      "right": "0",
      "z-index": "1024",
      "background-color": "rgba(0,0,0,0.3)",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "align-content": "center"
    }
  }, [_createElementVNode("div", _hoisted_33, [_createElementVNode("span", null, _toDisplayString(_ctx._t('uploadProgress')) + ":", 1), _createElementVNode("progress", {
    style: {
      "margin-left": "1rem"
    },
    value: $options.uploadProgress,
    max: "1"
  }, null, 8, _hoisted_34)])])) : _createCommentVNode("", true)]);
}